"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _colors = require("../../theme/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getBackgroundColor = function getBackgroundColor(type, disabled, variant, hover) {
  if (disabled && (type === 'primary' || type === 'black')) return _colors.colors.dataGrey;else if (variant === 'outlined') return '#fff';else if (type === 'primary' && hover) return _colors.colors.primaryGreenHover;else if (type === 'primary') return _colors.colors.primaryGreen;else if (type === 'black' && hover) return _colors.colors.secondaryGreen;else if (type === 'black') return _colors.colors.buttonBlack;else if (type === 'tertiary' && !disabled && hover) return _colors.colors.dataGrey;
  return 'transparent';
};

var getColor = function getColor(type, variant, disabled, hover) {
  if (disabled) return _colors.colors.black47;else if (type === 'primary') return _colors.colors.black80;else if (type === 'secondary' && variant === 'regular' && hover) return _colors.colors.primaryGreenHover;else if (type === 'black') return _colors.colors.primaryGreen;
  return _colors.colors.black80;
};

var getBorder = function getBorder(type, variant, disabled, hover) {
  if (type === 'secondary' && variant === 'outlined' && disabled) return "1px solid ".concat(_colors.colors.dataGrey);else if (type === 'secondary' && variant === 'outlined' && hover) return "1px solid ".concat(_colors.colors.primaryGreenHover);else if (type === 'secondary' && variant === 'outlined') return "1px solid ".concat(_colors.colors.black80);
  return 'none';
};

var getFontSize = function getFontSize(type, small) {
  if (type === 'tertiary' && small) return '0.875rem';else if (type === 'tertiary') return '1rem';else if (small) return '1rem';
  return '1.125rem';
};

var getHeight = function getHeight(type, small) {
  if (type === 'tertiary' && small) return '1.5rem';else if (type === 'tertiary') return '1.75rem';else if (small) return '2rem';
  return '2.5rem';
};

var getPadding = function getPadding(type, small) {
  if (type === 'tertiary') return '0.125rem 0.25rem';else if (small) return '0.25rem 1rem';
  return '0.5rem 1.5rem';
};

var useStyles = (0, _core.makeStyles)({
  root: {
    fontFamily: 'Novozymes, Arial',
    padding: function padding(props) {
      return getPadding(props.type, props.small);
    },
    fontSize: function fontSize(props) {
      return getFontSize(props.type, props.small);
    },
    height: function height(props) {
      return getHeight(props.type, props.small);
    },
    borderRadius: function borderRadius(props) {
      return props.type === 'tertiary' ? '0.25rem' : '3.625rem';
    },
    border: function border(props) {
      return getBorder(props.type, props.variant, props.disabled);
    },
    backgroundColor: function backgroundColor(props) {
      return getBackgroundColor(props.type, props.disabled, props.variant);
    },
    color: function color(props) {
      return getColor(props.type, props.variant, props.disabled);
    },
    textDecoration: function textDecoration(props) {
      return props.type === 'secondary' && props.variant !== 'outlined' ? 'underline' : 'none';
    },
    outline: 'none',
    textDecorationColor: function textDecorationColor(props) {
      return props.type === 'secondary' && props.variant !== 'outlined' && !props.disabled ? _colors.colors.primaryGreen : _colors.colors.dataGrey;
    },
    textUnderlinePosition: 'under',
    boxShadow: function boxShadow(props) {
      return props.shadow ? '0px 1px 5px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.02);' : 'none';
    },
    '&:hover': {
      backgroundColor: function backgroundColor(props) {
        return getBackgroundColor(props.type, props.disabled, props.variant, true);
      },
      color: function color(props) {
        return getColor(props.type, props.variant, props.disabled, true);
      },
      border: function border(props) {
        return getBorder(props.type, props.variant, props.disabled, true);
      },
      cursor: function cursor(props) {
        return props.disabled ? 'default' : 'pointer';
      },
      textDecorationColor: function textDecorationColor(props) {
        return !props.disabled ? _colors.colors.primaryGreenHover : _colors.colors.dataGrey;
      }
    }
  }
});

function Button(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      isSubmit = _ref.isSubmit,
      props = _objectWithoutProperties(_ref, ["onClick", "children", "isSubmit"]);

  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: props.id,
    type: isSubmit ? 'submit' : 'button',
    className: classes.root,
    onClick: onClick
  }, children);
}

Button.defaultProps = {
  variant: 'regular',
  small: false,
  type: 'primary',
  disabled: false
};